module.exports = __webpack_public_path__ + "img/12.c3cb1874.jpg";